import axios from 'axios';

// ----------------------------------------------------------------------
const proto = window.location.protocol;
console.log(proto);
const Server =
  process.env.NODE_ENV === 'production'
    ? `${proto}//proplus.advanceworldgroup.com/api/v1/`
    : 'http://localhost:5000/api/v1/';

const accessToken = window.localStorage.getItem('accessToken');

const axiosInstance = axios.create({
  baseURL: Server,
  headers: {
    authorization: `Bearer ${accessToken}`
  }
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;
